
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/automotive-software/tyre-fitment-centre-software",
      function () {
        return require("private-next-pages/automotive-software/tyre-fitment-centre-software.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/automotive-software/tyre-fitment-centre-software"])
      });
    }
  